/*
 * Sunvolt – ömsesidig inkompatibilitet mellan tillval/produkter (regelmotor).
 * ---------------------------------------------------------------------------
 * Återanvändbart datakontrakt (sätts av Liquid via snippet 'sunvolt-compat-attrs'):
 *   root[data-sv-base-handle]  – basproduktens handle (alltid "aktiv")
 *   root[data-sv-base-title]   – basproduktens namn (för noten)
 *   rad[data-sv-handle]        – radens produkt-handle
 *   rad[data-sv-conflicts="h1 h2"] – handles som raden INTE kan kombineras med
 *   rad[data-sv-requires="h1 h2"]  – raden kräver att MINST ETT av dessa handles
 *                                    är aktivt (basen eller ett ibockat tillval);
 *                                    annars gråas den (och bockas ur om kravet bryts)
 *
 * Källa: Tillval-metaobjektets fält `oforenlig_med`/`kraver` (listor med
 * produktreferenser), med produktens metafält custom.oforenlig_med/custom.kraver
 * som fallback (se snippets/sunvolt-compat-attrs.liquid).
 * Relationen är SYMMETRISK – räcker att peka ut krocken på ena sidan. Basprodukten
 * räknas alltid som vald, så ett tillval som pekar på basens handle gråas permanent
 * (t.ex. TP2 på en DC-laddare). Motorn kan återanvändas för fler regler senare –
 * lägg till fler data-attribut + fler pass i apply().
 */
(function () {
  if (window.SunvoltCompat) return;
  function norm(s) { return (s == null ? '' : String(s)).trim(); }

  window.SunvoltCompat = function (root, opts) {
    if (!root || root.__svCompat) return;
    opts = opts || {};
    var rowSel = opts.rowSel;
    var inputSel = opts.inputSel;
    var noteTargetSel = opts.noteTargetSel || null;
    var onChange = typeof opts.onChange === 'function' ? opts.onChange : function () {};
    if (!rowSel || !inputSel) return;

    var baseHandle = norm(root.getAttribute('data-sv-base-handle'));
    var baseTitle = root.getAttribute('data-sv-base-title') || '';

    var items = Array.prototype.slice.call(root.querySelectorAll(rowSel)).map(function (row) {
      var input = row.querySelector(inputSel);
      var conflicts = norm(row.getAttribute('data-sv-conflicts')).split(/\s+/).filter(Boolean);
      return {
        row: row,
        input: input,
        handle: norm(row.getAttribute('data-sv-handle')),
        conflicts: conflicts,
        requires: norm(row.getAttribute('data-sv-requires')).split(/\s+/).filter(Boolean),
        stockDisabled: !!(input && input.disabled),
        eff: {},
        noteEl: null,
        label: (row.getAttribute('data-title-base') || row.getAttribute('data-title') || '').trim()
      };
    }).filter(function (it) { return it.handle || it.conflicts.length || it.requires.length; });

    if (!items.length) { root.__svCompat = true; return; }

    /* handle → läsbart namn (för noten) */
    var labelByHandle = {};
    if (baseHandle) labelByHandle[baseHandle] = baseTitle;
    items.forEach(function (it) { if (it.handle && !labelByHandle[it.handle]) labelByHandle[it.handle] = it.label; });

    /* effektiv (symmetrisk) konfliktmängd: A→B implicerar B→A */
    items.forEach(function (it) { it.conflicts.forEach(function (h) { it.eff[h] = true; }); });
    items.forEach(function (a) {
      if (!a.handle) return;
      a.conflicts.forEach(function (h) {
        items.forEach(function (b) { if (b.handle && b.handle === h) b.eff[a.handle] = true; });
      });
    });

    var hasRules = items.some(function (it) { return Object.keys(it.eff).length || it.requires.length; });
    if (!hasRules) { root.__svCompat = true; return; }

    function activeHandles() {
      var set = {};
      if (baseHandle) set[baseHandle] = true;
      items.forEach(function (it) {
        if (it.input && it.input.checked && !it.input.disabled && it.handle) set[it.handle] = true;
      });
      return set;
    }

    function ensureNote(it) {
      if (it.noteEl) return it.noteEl;
      var host = noteTargetSel ? (it.row.querySelector(noteTargetSel) || it.row) : it.row;
      var n = document.createElement('span');
      n.className = 'sv-incompat-note';
      host.appendChild(n);
      it.noteEl = n;
      return n;
    }

    function applyOnce() {
      var active = activeHandles();
      var changed = false;
      items.forEach(function (it) {
        if (!it.input) return;
        var clash = null;
        for (var h in it.eff) {
          if (h !== it.handle && active[h]) { clash = h; break; }
        }
        var reqMiss = null;
        if (it.requires.length) {
          var okReq = it.requires.some(function (h) { return !!active[h]; });
          if (!okReq) reqMiss = it.requires;
        }
        var hardBase = clash && clash === baseHandle; // krock mot basprodukten = permanent
        if (clash && (!it.input.checked || hardBase)) {
          if (hardBase && it.input.checked) { it.input.checked = false; changed = true; }
          if (!it.stockDisabled) it.input.disabled = true;
          it.row.classList.add('is-incompat');
          ensureNote(it).textContent = 'Kan ej kombineras med ' + (labelByHandle[clash] || 'ett annat val');
        } else if (reqMiss) {
          /* kravet ej uppfyllt – bocka ur om ibockad (kravet togs bort) och grå ut */
          if (it.input.checked) { it.input.checked = false; changed = true; }
          if (!it.stockDisabled) it.input.disabled = true;
          it.row.classList.add('is-incompat');
          var reqNames = reqMiss.map(function (h) { return labelByHandle[h] || h; }).join(' eller ');
          ensureNote(it).textContent = 'Kräver ' + reqNames;
        } else {
          it.row.classList.remove('is-incompat');
          if (!it.stockDisabled && it.input.disabled) it.input.disabled = false;
          if (it.noteEl) it.noteEl.textContent = '';
        }
      });
      return changed;
    }
    /* ur-bockningar kan kaskada (t.ex. kravkedjor) → kör tills stabilt (max 4 varv) */
    function apply() {
      var guard = 0;
      while (applyOnce() && ++guard < 4) {}
    }

    items.forEach(function (it) {
      if (it.input) it.input.addEventListener('change', function () { apply(); onChange(); });
    });

    apply();
    onChange();
    root.__svCompat = true;
  };
})();
